export default class Afiliate {
    constructor(props) {
        Object.assign(this, props);
    }
}
export const TypeCommission = {
    Fix: 'fix',
    Percentage: 'percentage'
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Afiliates/Afiliate.ts
// module id = 242
// module chunks = 0